module.exports = __webpack_public_path__ + "img/payment_failed.2c0fd547.svg";